import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n";
import { setLenis } from "./lib/site";
import { Landing } from "./components/site/Landing";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); setLenis(null); };
  }, []);

  return (
    <I18nProvider>
      <div className="grain relative min-h-screen bg-paper text-ink">
        <Landing />
        <Toaster position="bottom-center" toastOptions={{ style: { background: "#1A1A1A", color: "#FDFBF7", border: "none" } }} />
      </div>
    </I18nProvider>
  );
}

export default App;
